import {createTheme} from '@mui/material/styles';
import React, {createContext, ReactNode, useContext, useEffect, useState} from 'react';
import {ThemeProvider as EmotionThemeProvider} from '@emotion/react';

enum ThemeMode {
	Dark = 'dark',
	Light = 'light',
}

const emptyFn = () => {
	return;
};

const initialState = {
	isDarkModeOn: false,
	theme: ThemeMode.Dark,
	toggleDarkMode: emptyFn,
};

const ThemeContext = createContext(initialState);

export const BRAND_YELLOW = '#ffc85e';
export const BRAND_CONTRAST_TEXT = '#3A3042';

export function ThemeProvider({ children }: {children: ReactNode}) {
	const [dark, setDark] = useState(false);

	useEffect(() => {
		const isLight = localStorage.getItem('dark') === 'false';
		setDark(!isLight);
	}, []);

	const toggle = () => {
		const isDark = !dark;
		localStorage.setItem('dark', JSON.stringify(isDark));
		setDark(isDark);
	};

	const theme = createTheme({
		palette: {
			mode: dark ? ThemeMode.Dark : ThemeMode.Light,
			primary: {
				main: dark ? '#d53f3f' : '#3A3042',
			},
			// secondary: {
			// 	main: dark ? '#8ab2dd' : '#8ab2dd',
			// },
			// background: {
			// 	paper: dark ? '#1e1e1e' : '#f9f9f9',
			// },
		},
		typography: {
			// fontFamily: 'Lexend, serif',
			h2: {
				fontSize: '2.5rem',
				'@media (max-width:600px)': {
					fontSize: '1.8rem',
				},
			},
			body1: {
				fontWeight: 300,
			},
		},
	});
	
	return (
		<ThemeContext.Provider value={{
			theme: dark ? ThemeMode.Dark : ThemeMode.Light, 
			toggleDarkMode: toggle, 
			isDarkModeOn: dark 
		}}>
			<EmotionThemeProvider theme={theme}>
				{children}
			</EmotionThemeProvider>
		</ThemeContext.Provider>
	);
}

export const useThemeContext = () => useContext(ThemeContext);
